export default "<div id=\"hsformContainer\">\n</div>\n"